<template>
    <v-select
          :options="convertFieldsToOptions(facetFields)"
          multiple
          class="relative v-select"
          :value=filters.values
          :close-on-select="false"
          :select-on-tab="true"
          :placeholder="searchablePlaceHolder"
          :selectable="(option) => selectableOption(option)"
          @input="(selection) => searchableChange(selection)"
        />
</template>
<script>
export default {
  props: {
    facetFields: {
      type: [Array, Object],
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    selectedFields: {
      type: [Array, Object],
      required: false,
    }
  },
  data() {
    return {
      filters: {
        'name': this.fieldName,
        'values': [],
      },
    }
  },
  mounted() {
    this.setSelectedFields();
  },
  computed: {
    searchablePlaceHolder() {
      return 'Search ' + this.label + '...'
    },
    selectedOptions() {
        if(this.fieldName in this.selectedFields) {
            return this.selectedFields[this.fieldName];
        }
        return []
    }
  },
  methods: {
    convertFieldsToOptions(fields) {
      var options = [];
      for(var field in fields){
        options.push(fields[field].key);
      }
      return options;
    },
    searchableChange(selection) {
      this.filters.values = selection;
      this.$emit('set-filters', this.filters);
    },
    selectableOption(option){
      if (this.filters.values.includes(option)){
        return false
      }
      return true
    },
    setSelectedFields() {
      if (this.selectedFields[this.fieldName]) {
        return this.filters.values = this.selectedFields[this.fieldName];
      }
    },
  }
}
</script>
